import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangHrIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M18 9a8.98 8.98 0 0 0-.56-3.13L9 5.479l-8.44.39A8.98 8.98 0 0 0 0 9c0 1.101.198 2.156.56 3.13l8.44.392 8.44-.391A8.98 8.98 0 0 0 18 9Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 18a9.003 9.003 0 0 0 8.44-5.87H.56A9.003 9.003 0 0 0 9 18Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M.56 5.87h16.88a9.003 9.003 0 0 0-16.88 0Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.348 6.26H9.783l.26-1.956 1.044-.783 1.043.783V5.87l-.782.392Zm-4.696 0h1.565l-.26-1.956-1.044-.783-1.043.783V5.87l.782.392Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.044 6.26H7.957V4.305L9 3.521l1.044.783v1.957Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.87 5.87v4.304c0 1.024.495 1.936 1.258 2.507l.548-.137.691.696a3.134 3.134 0 0 0 1.262 0l.79-.657.453.097a3.127 3.127 0 0 0 1.258-2.506V5.869H5.87Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.87 5.87h1.252v1.25H5.87V5.87Zm2.504 0h1.252v1.25H8.374V5.87Zm2.504 0h1.253v1.25h-1.253V5.87ZM7.122 7.121h1.252v1.252H7.122V7.121Zm2.504 0h1.252v1.252H9.626V7.121ZM5.87 8.373h1.252v1.252H5.87V8.373Zm1.252 1.252h1.252v1.252H7.122V9.625Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.374 8.373h1.252v1.252H8.374V8.373Zm2.504 0h1.253v1.252h-1.253V8.373ZM9.626 9.625h1.252v1.252H9.626V9.625Zm-1.252 1.252h1.252v1.252H8.374v-1.252Zm-1.252.001H5.95c.108.465.32.891.609 1.252h.563v-1.252Zm3.756 1.252h.563c.29-.36.501-.787.609-1.252h-1.172v1.252Zm-3.756 0v.546c.364.274.79.47 1.252.565V12.13H7.122Zm2.504 0v1.111c.463-.094.888-.29 1.252-.565v-.546H9.626Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h18v18H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgLangHrIconmin);
export { ForwardRef as ReactComponent };
